import { motion } from "framer-motion";
import Link from "next/link";
import { useRouter } from "next/router";
import { LinkType } from "types/allTypes";
import { menuItemAni } from "utils/animation";

interface props {
  link: LinkType;
  cycleIsExpanded: () => void;
}
const MobileMenuItem: React.FC<props> = ({ link,cycleIsExpanded }) => {
    const router = useRouter();
  return (
    <motion.li
    onClick={cycleIsExpanded}
    variants={menuItemAni}
    whileHover={{scale:1.05}}
    whileTap={{scale:0.95}}
    className={`mb-6 flex justify-start cursor-pointer hover:text-primary-70 duration-300 ${router.pathname === link.ref && "font-bold text-primary-60"}`}>
      <Link href={link.ref}>
        {link.text}
      </Link>
    </motion.li>
  );
};

export default MobileMenuItem;
